<script>
	import Helper from '../../Classes/Helper';
	import Menu from '../../Stores/Menu';
	import Product from '../../Stores/Product';

	let name = '';

	function setName() {
		const type = $Product.property.property_type;
		const generic = $Product.group.title || Product.getPropertyName($Product.property);
		name = (type === 'upsells') ? $Product.property.title : generic;
		if (!name) name = 'Geen opties beschikbaar';
	}

	Product.subscribe(data => {
		if (Helper.is(data))
			setName();
	});
</script>

<style>
	div.zes-title {
		display: flex;
		padding: .15em 1.25em .75em 1.25em;
		margin-bottom: .45em;
	}

	div.zes-title > div:nth-child(1) {
		flex-grow: 1;
	}

	div.zes-title > div:nth-child(1) div {
		font-size: 2.25em;
		font-weight: 400;
		letter-spacing: -.025em;
		color: var(--zes-1-2);
	}

	div.zes-title > div:nth-child(2) {
		padding-top: 1em;
		padding-left: 1em;
		display: none;
	}

	div.zes-title > div:nth-child(2) i {
		font-size: 1.75em;
		color: var(--zes-1-2);
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-title > div:nth-child(2) {
			display: block;
		}
	}
</style>

<div class="zes-title">
	{#if $Product.property}
		<div>
			<div>{$Product.step.description_active ? 'Hulp' : name}</div>
		</div>
	{/if}
	<div on:click="{event => $Menu.open = true}">
		<i class="fa-solid fa-bars"></i>
	</div>
</div>